export default class EventHandler<EventArgs> {
    private handlers: { (model: EventArgs): void; }[] = [];

    get handlerCount() {
        return this.handlers.length;
    }

    on = (handler: { (model: EventArgs): void; }) => {
        if (this.handlers.indexOf(handler) === -1) {
            this.handlers.push(handler);
        }
    };
    off = (handler: { (model: EventArgs): void; }) => {
        const handlerIndex = this.handlers.indexOf(handler);
        if (handlerIndex === -1)
            return;
        this.handlers.splice(handlerIndex, 1);
    };

    offAll = () => {
        this.handlers.map(x => this.off(x));
    };

    invoke = (args: EventArgs) => {
        this.handlers.forEach((handler) => {
            try {
                handler(args);
            }
            catch (e) { console.error(e); }
        });
    };

    peekHandlers = () => [...this.handlers];
}
export class KeyedEventHandler<TKey, TEventArgs> {
    private handlers: Map<TKey, EventHandler<TEventArgs>> = new Map();

    getHandler = (key: TKey) => {
        return this.handlers.get(key);
    };

    getOrCreateHandler = (key: TKey) => {
        if (!this.handlers.has(key)) {
            this.handlers.set(key, new EventHandler<TEventArgs>());
        }
        return this.getHandler(key)!;
    };

    removeHandler = (key: TKey) => {
        this.handlers.delete(key);
    };

    on = (key: TKey, handler: { (model: TEventArgs): void; }) => {
        this.getOrCreateHandler(key).on(handler);
    };

    off = (key: TKey, handler: { (model: TEventArgs): void; }) => {
        const eventHandler = this.getHandler(key);
        eventHandler?.off(handler);
        if (eventHandler && eventHandler.handlerCount === 0) {
            this.removeHandler(key);
        }
    };

    invoke = (key: TKey, args: TEventArgs) => {
        this.getHandler(key)?.invoke(args);
    };
}
export type EventHandlerModel<TEventHandler> = TEventHandler extends EventHandler<infer TModel> ? TModel : never;


export class NotImplementedEventHandler<EventArgs> extends EventHandler<EventArgs> {
    on = () => {
        throw new Error('Function not implemented.');
    };
    invoke = () => {
        throw new Error('Function not implemented.');
    };
}